module.exports = __webpack_public_path__ + "static/img/download-center.06070cfe.svg";